
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"16","height":"17","fill":"none"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill":"#2A333D","d":"M1.333 2.167h13.333v4H1.333zm0 5h4.333V10.5H1.333zm5.334 0h8V10.5h-8zM1.333 11.5h4.333v3.333H1.333zm5.334 0h8v3.333h-8z"}})])
          )
        }
      }
    